import axios from "axios";
import {useQuery} from "@tanstack/vue-query";
import {computed, ref} from "vue";
import {crawlInProgress} from "@/composables/crawler/useCrawler";

const staleTime = 1000 * 60 * 60 * 24 * 30;

const getGBPLocations = () => useQuery({
  queryKey: ['gbp-locations'],
  queryFn: async () => {
    const {data} = await axios.get(
      `/ajax/v2/gbp-locations`
    );

    return data.data;
  },
  staleTime,
});

export {
  getGBPLocations,
};
